import React,{useState,useEffect} from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings";
import Hero from "components/headers/light";
import NewsFeed from "components/blogs/NewsFeed";
import Footer from "../../components/Footer";
import AdComponent from '../../components/AdComponent.js'
import {useAppDispatch, loadNews, useAppSelector} from "../../redux";

const Container = tw.div`max-w-screen-xl mx-auto  `
const Div = tw.div`w-full  mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const One = tw.div`lg:m-3 `
const ContentWithPaddingXl = tw.div`pt-24 min-h-screen max-w-screen-xl mx-auto lg:flex justify-center `
const Hr = tw.hr`mt-2 `
export default ({ headingText = "Terms And Condition" }) => {
  const dispatch = useAppDispatch();

  const [footerShow, setFooterShow] = useState("")
  
  const news = useAppSelector(state => state.news.news)
  

  useEffect(() => {
    if (news.length === 0) {
      dispatch(loadNews());
    }
  }, [dispatch])
  useEffect(() => {
    setTimeout(() => {
      setFooterShow("true")
      
    }, 1000);

  }, [])
  return (
    <>
      <Div>
        <Hero />
        <Hr/>
      </Div>
      <Container>
        <AdComponent/>
        <ContentWithPaddingXl>
          <One>
            <NewsFeed news={news}/>
          </One>

          {/* {actress.length > 0 && <Two>
          <TextTwo>Latest Gallery</TextTwo>
          {actress.map((item) => (
            <Div key={item.id}>
              <ImageRight src={item.url} />
            </Div>

          ))}
          <Text />

        </Two>} */}

        </ContentWithPaddingXl>
      </Container>
      {footerShow?<Footer />: <></>}
      
    </>
  );
};
